module.exports = {"510725100":"文昌镇","510725101":"长卿镇","510725102":"许州镇","510725103":"黎雅镇","510725104":"白云镇","510725105":"卧龙镇","510725106":"观义镇","510725107":"玛瑙镇","510725108":"石牛镇","510725109":"自强镇","510725110":"仁和镇","510725200":"东石乡","510725201":"三泉乡","510725202":"宏仁乡","510725203":"小垭乡","510725204":"演武乡","510725205":"仙峰乡","510725206":"双板乡","510725207":"豢龙乡","510725208":"双峰乡","510725209":"交泰乡","510725210":"金龙场乡","510725211":"石台乡","510725212":"仙鹅乡","510725213":"马鸣乡","510725214":"马迎乡","510725215":"二洞乡","510725216":"建兴乡","510725217":"宝石乡","510725218":"定远乡","510725219":"大新乡","510725220":"文兴乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510725.json
// module id = 2125
// module chunks = 0